import * as Stimulus from "@hotwired/stimulus"

/**
 * Controls dismissable page elements. Elements are removed
 * from the DOM when the dismiss action is fired.
 **/
export class ConfirmationController extends Stimulus.Controller {
    confirm(e) {
        if(!confirm(e.params.message)) {
            e.preventDefault();
        }
    }
}
